import React, { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Overview from './components/Overview';
import LearnPillars from './components/LearnPillars';
import KeyFeatures from './components/KeyFeatures';
import Tools from './components/Tools';
import Curriculum from './components/Curriculum';
import Projects from './components/Projects';
import Internship from './components/Internship';
import Placement from './components/Placement';
import PlacementPilot from './components/PlacementPilot';
import CareersMarquee from './components/CareersMarquee';
import EverythingIncluded from './components/EverythingIncluded';
import Certifications from './components/Certifications';
import CourseFee from './components/CourseFee';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <Nav />
      <Hero />
      <Overview />
      <LearnPillars />
      <KeyFeatures />
      <Tools />
      <Curriculum />
      <Projects />
      <Internship />
      <Placement />
      <PlacementPilot />
      <CareersMarquee />
      <EverythingIncluded />
      <Certifications />
      <CourseFee />
      <Footer />
    </div>
  );
}

export default App;
